// /*
//  *  -----------------------------------------------------------------------
//  *    <copyright file="attendees-grid.data.ts" company="Triumph Research Intelligence">
//  *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
//  *    </copyright>
//  *   -----------------------------------------------------------------------
//  *
//  */

import { TFunction } from 'i18next';
import createGridCustomCells from '@components-clean/core/grid/custom-cell';
import { DateTimeCell, YesNoCell } from '@components-clean/core/grid-fe/custom-cells';
import { GridColumnProps } from '@components-clean/core/grid-fe/grid.interface';

const { TooltipCell } = createGridCustomCells();

export function getRiskReviewAttendeesGridColumns(t: TFunction<'translation', undefined>): GridColumnProps[] {
    return [
        {
            id: 'active',
            field: 'active',
            title: t('common:active'),
            minWidth: 100,
            width: 1,
            filter: 'boolean',
            cells: { data: YesNoCell },
        },
        {
            id: 'firstName',
            field: 'firstName',
            title: t('firstName'),
            minWidth: 200,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'lastName',
            field: 'lastName',
            title: t('lastName'),
            minWidth: 200,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'jobTitle',
            field: 'jobTitle',
            title: t('ra:jobTitle'),
            minWidth: 200,
            width: 1,
            filter: 'text',
            cells: {
                data: TooltipCell({
                    isCsv: false,
                }),
            },
        },
        {
            id: 'createdByName',
            field: 'createdByName',
            title: t('ra:createdBy'),
            minWidth: 125,
            width: 1,
            showByDefault: false,
            filter: 'text',
        },
        {
            id: 'createdDate',
            field: 'createdDate',
            title: t('ra:createdDate'),
            minWidth: 100,
            width: 1,
            showByDefault: false,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'updatedByName',
            field: 'updatedByName',
            title: t('ra:updatedBy'),
            minWidth: 125,
            width: 1,
            filter: 'text',
        },
        {
            id: 'updatedDate',
            field: 'updatedDate',
            title: t('ra:updatedDate'),
            minWidth: 100,
            width: 1,
            filter: 'date',
            cells: { data: DateTimeCell('DD-MMM-yyyy') },
            cellName: 'DateCell',
        },
        {
            id: 'id',
            minWidth: 100,
            width: 1,
            field: '_itemId',
            showByDefault: false,
            title: t('id'),
        },
    ];
}
